import { render, staticRenderFns } from "./GlobalTopCategoriesGD.vue?vue&type=template&id=39087cda&scoped=true&"
import script from "./GlobalTopCategoriesGD.vue?vue&type=script&lang=js&"
export * from "./GlobalTopCategoriesGD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39087cda",
  null
  
)

export default component.exports